module.exports = __webpack_public_path__ + "static/img/px.74ec5efd.webp";